/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice\src\Content\DateBtnForm\DateBtnForm.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice
 * Created Date: Friday October 18th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday October 18th 2024 10:19:10 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { Button } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";

type DateBtnFormProps = {
    date: Dayjs | null,
    setter: Function,
    updateValue: Function,
    updateKey: string
};

export default function DateBtnForm(props: DateBtnFormProps) {
    const [date, setDate] = useState<Dayjs | null>(null);

    const handleCreatePicker = () => {
        props.setter(dayjs().set("second", 0).set("millisecond", 0));
        props.updateValue(dayjs().set("second", 0).set("millisecond", 0), props.setter, props.updateKey);
    };

    useEffect(() => {
        setDate(props.date);
    }, [props.date]);

    return (
        date ?
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
                <DatePicker sx={{'& .MuiInputBase-input': {padding: "0.5rem 0rem"},}} format={"DD-MM-YYYY"} value={date} onChange={(start: dayjs.Dayjs | null) => props.updateValue(start, props.setter, props.updateKey)}/>
            </LocalizationProvider>
            :
            <Button onClick={handleCreatePicker}>
                +
            </Button>
    );
};
